import { InjectionToken } from '@angular/core';

export const TT_INPUT_HOST = new InjectionToken('TT_INPUT_HOST');
